import React from 'react';
import { ChevronRight, Shield, Download, Zap } from 'lucide-react';
export function Pricing() {
  return <section id="compra" className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-97">
      <div className="max-w-4xl mx-auto" data-id="element-98">
        <div className="bg-gradient-to-br from-gray-900 to-black border-2 border-[#C6FF3C] rounded-2xl p-8 md:p-12" data-id="element-99">
          <div className="text-center mb-8" data-id="element-100">
            <span className="inline-block px-6 py-2 bg-red-600 text-white font-bold text-sm uppercase rounded-full mb-4" data-id="element-101">
              Oferta por Tiempo Limitado
            </span>
            <h2 className="headline-font text-3xl md:text-4xl text-white uppercase mb-6" data-id="element-102">
              Conseguí{' '}
              <span className="text-[#C6FF3C]" data-id="element-103">Padel Smart Pro Elite</span> Hoy
            </h2>
          </div>

          <div className="text-center mb-8" data-id="element-104">
            <p className="text-gray-400 text-xl line-through mb-2" data-id="element-105">
              Precio Regular: $49.990
            </p>
            <div className="flex items-center justify-center gap-4 mb-4" data-id="element-106">
              <p className="text-[#C6FF3C] text-6xl md:text-7xl font-bold" data-id="element-107">
                $19.990
              </p>
            </div>
            <div className="inline-block bg-[#C6FF3C] text-black font-bold px-6 py-3 rounded-lg text-xl" data-id="element-108">
              AHORRÁS $30.000 (60% OFF)
            </div>
          </div>

          <div className="mb-8" data-id="element-109">
            <a href="https://checkout.ebookpoint.shop/cart/59500238602321:1" className="block w-full bg-[#C6FF3C] hover:bg-[#A4E635] text-black font-bold text-xl md:text-2xl px-8 py-6 rounded-lg uppercase tracking-wide transition-all duration-300 text-center shadow-lg shadow-[#C6FF3C]/20 hover:shadow-xl hover:shadow-[#C6FF3C]/30" data-id="element-110">
              <span className="flex items-center justify-center gap-3" data-id="element-111">
                Quiero Padel Smart Pro Elite Ahora
                <ChevronRight className="w-7 h-7" data-id="element-112" />
              </span>
            </a>
          </div>

          <div className="grid md:grid-cols-3 gap-4 text-center" data-id="element-113">
            <div className="flex flex-col items-center gap-2" data-id="element-114">
              <Shield className="w-8 h-8 text-[#C6FF3C]" data-id="element-115" />
              <p className="text-sm text-gray-400" data-id="element-116">Pago Seguro</p>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-117">
              <Zap className="w-8 h-8 text-[#C6FF3C]" data-id="element-118" />
              <p className="text-sm text-gray-400" data-id="element-119">Acceso Inmediato</p>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-120">
              <Download className="w-8 h-8 text-[#C6FF3C]" data-id="element-121" />
              <p className="text-sm text-gray-400" data-id="element-122">Descarga Digital</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}